import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import {Link} from 'react-router-dom';

class ContainerDesignGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      containerdesignGallerypage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "containerdesignGallery",
      //'order': 'sys.createdAt'
    }).then((entries) => {
      this.setState({ containerdesignGallerypage: entries.items});
    });
  }

  redirectToTarget=()=>{
    this.props.history.push('/container-design-program')
  }


  render() {
    return (
      <>
      <div className="container-fluid text-left">
        <h1>CONTAINER DESIGN PROGRAM GALLERY</h1>
      </div>
      <div>
        {this.state.containerdesignGallerypage.length === 0 ?
          <div><img src={BlackLoading} alt="Loading..." /></div> :
              <div className="grid">
                  {this.state.containerdesignGallerypage.map((item, num=0) => {
                      num = num + 1
                      return (
                          <div key={num} className="col-md-2 col-12">
                              <input type="checkbox" id={num} />
                              <label htmlFor={num} className="lightbox"><img src={item.fields.containerdesignGalleryPhoto.fields.file.url} alt="container design program photos" /></label>
                              <label htmlFor={num}><img src={item.fields.containerdesignGalleryPhoto.fields.file.url} alt="container design program photos" /></label>
                              {/* <p className="text-center">{item.fields.containerdesignGalleryTitle}</p> */}
                          </div>
                      )
                  })}
            </div>
      }

      </div>
      <div className="container-fluid">
      <p><Link to="#" onClick={this.redirectToTarget}><button className="btn btn-primary">Back to Container Design</button></Link></p>
      </div>
    </>
    );
  }
}

export default ContainerDesignGallery;
